import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import * as yup from "yup";
import { Stack } from "@mui/material";
import { Button, TextInput } from "components/forms";
import { Formik } from "formik";
import { useActionHook } from "hooks";
import { useAuthActions } from "store";

import { Routes } from "../../constants/routes";

const emailInitValues: { [email: string]: string } = {
  email: ""
};

const emailValidation = yup.object().shape({
  email: yup.string().email().required()
});

export const EmailForm: React.FC = () => {
  const { forgotPasswordAction } = useAuthActions();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const { push } = useHistory();

  const {
    error: forgotPassErrors,
    loading: forgotPassLoading,
    action: forgotPass,
    resetError
  } = useActionHook(forgotPasswordAction, {
    onSuccess: () => {
      setIsSuccess(true);
    }
  });

  return isSuccess ? (
    <Stack className="reset-email-form success-msg" sx={{ lineHeight: "1.1" }}>
      The instructions and the relevant link for resetting the password has been sent to the email.
    </Stack>
  ) : (
    <Formik
      initialValues={emailInitValues}
      validationSchema={emailValidation}
      onSubmit={async (values, { resetForm }) => {
        await forgotPass(values.email);
        resetForm();
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors, isValid }) => (
        <form className="reset-email-form" onSubmit={handleSubmit}>
          <span className="reset-password__message">
            Enter your email address below and we’ll send you link to reset your password
          </span>
          <TextInput
            // label="Enter your email address below and we’ll send you link to reset your password"
            placeholder="Your email"
            className="forgot-password__input"
            value={values.email}
            onChange={(event) => {
              setFieldValue("email", event.target.value);
              if (forgotPassErrors) {
                resetError();
              }
            }}
            errors={forgotPassErrors ? [forgotPassErrors?.errors?.email] : errors.email ? [errors.email] : []}
          />
          <div className="btn-block">
            <Button
              title="Send Email"
              variant="square"
              className="reset-password__button"
              isLoading={forgotPassLoading}
              type="submit"
              disabled={!isValid || !!forgotPassErrors}
              // disabled={!!Object.values(errors).length || !!backErrors}
            />
            <Button
              title="Go to login"
              variant="square-light-border"
              className="reset-password__button"
              isLoading={forgotPassLoading}
              onClick={() => push(Routes.login)}
              disabled={forgotPassLoading}
            />
          </div>
        </form>
      )}
    </Formik>
  );
};
